//
// Based on hoverIntent (http://briancherne.github.io/jquery-hoverIntent/)
// 
// Similar to jQuery hover, except the hoverOver, hoverOut are only called
// once the user has been determined to "intend" to hover.  This is determined
// by tracking the mouse and seeing if the user has "slowed down" enough to seem
// like they are trying to stop and hover, vs. just moving through.
//
//  .hoverIntent(handlerOver, handlerOut) can be called on any jQuery object.
//  if handlerOut is ommitted handlerOver will also be used for handlerOut (matches jQuery.hover)
//  handlerOver can also be an object specifying the handlers plus additional options:
//
//  {
//      handlerOver
//      handlerOut
//      hoverOverInterval (default 100)
//      hoverOverTravelAllowance (default 6)
//      hoverOutDelay (default 0)
//  }
//
(function($) {
    'use strict';

    const _stateStorageKey = "_hoverIntent_";
    const _eventNamespace = ".hoverIntent";

    // default configuration values
    var _defaultOptions = {
        hoverOverInterval: 100,
        hoverOverTravelAllowance: 6,
        hoverOutDelay: 0
    };

    // counter used to generate an ID for each instance
    var INSTANCE_COUNT = 0;

    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    var mouse = { x: null, y: null };

    //
    // Composes a namespaced event name in the form of name.namespace.[extra]
    // 
    function _eventName(name, ...extras) {
        var eventName = `${name}.${_eventNamespace}`;

        for (var extra of extras) {
            eventName += "." + extra;
        }

        return eventName;
    }

    //
    // Saves the current pointer position coordinates based on the given mousemove event
    //
    function _onMouseMove(event) {
        mouse.x = event.pageX;
        mouse.Y = event.pageY;
    }

    //
    // Checks to see if we consider hover to have started based on where the mouse is now, and where it was before
    //
    function _checkForHoverStart(event, element, state, options) {

        // Compare mouse positions to see if pointer has slowed enough to trigger "intent"
        if (Math.sqrt((state.x - mouse.x) * (state.x - mouse.x) +
                      (state.y - mouse.y) * (state.y - mouse.y))   <= options.hoverOverTravelAllowance) {

            element.off(_eventName("mousemove", options.instanceID), _onMouseMove);
            state.timeoutID = null;

            // We are now actively hovering, and will trigger a hoverOut at some point
            state.isActive = true;

            // overwrite old original mouseenter event coordinates with most recent pointer position
            event.pageX = mouse.x;
            event.pageY = mouse.y;

            // clear coordinate data from state object
            state.x = null;
            state.y = null;

            return options.handlerOver.apply(element[0], [event]);
        }
        else {
            // set previous coordinates for next comparison
            state.x = mouse.x;
            state.y = mouse.y;

            // Keep polling
            state.timeoutID = setTimeout(
                function () {
                    _checkForHoverStart(event, element, state, options);
                },
                options.hoverOverInterval);
        }
    }

    // 
    // Triggered after the mouseleave delay to actually end our hover state
    // 
    function _onHoverOut(event, element, state, options) {

        // Remove the state for this instance
        _getStateStorage(element)[state.instanceID] = null;

        // Call the handler
        return options.handlerOut.apply(element[0], [event]);
    }

    //
    // Return the storage object used to store state instances for the given element
    //
    function _getStateStorage(element) {
        var stateStorage = element.data(_stateStorageKey);
        if (!stateStorage) {
            element.data(_stateStorageKey, (stateStorage = {}));
        }

        return stateStorage;
    }

    //
    // Gets our internal state for the given element.
    // state properties:
    // instanceID = instance ID, used to clean up data
    // timeoutID = timeout ID, reused for tracking mouse position and delaying "out" handler
    // isActive = plugin state, true after `handlerOver` is called just until `out` is called
    // x, y = previously-measured pointer coordinates, updated at each polling interval
    //
    function _getState(element, instanceID) {

        var stateStorage = _getStateStorage(element);

        // Get this specific state from our internal data
        var state = stateStorage[instanceID];
        if (!state) {
            state = stateStorage[instanceID] = { instanceID: instanceID };
        }

        return state;
    }

    //
    // Public jQuery extension function that adds hover over\out handlers that only fire after "intent" is established.
    //
    function hoverIntent(handlerOver, handlerOut) {

        // Each call over hoverIntent creates a new "instance" 
        var instanceID = INSTANCE_COUNT++;

        // Create options from the defaults to start
        var options = $.extend({}, _defaultOptions);

        // If the first parameter is an object, it represents option overides
        if ($.isPlainObject(handlerOver)) {
            options = $.extend(options, handlerOver);
        }
        else {
            options = $.extend(options, { handlerOver, handlerOut } );
        }

        // If an out wasn't specified, we default it to the same as the over (matches jQuery)
        if (!$.isFunction(options.handlerOut)) {
            options.handlerOut = options.handlerOver;
        }

        //
        // A private function for handling mouse 'hovering'
        //
        function _handleHover(event) {

            // Cloned event to pass to handlers (copy required for event object to be passed in IE)
            event = $.extend({}, event);

            // the current target of the mouse event, wrapped in a jQuery object
            var element = $(this);
            var state = _getState(element, instanceID);

            // clear any existing timeout
            if (state.timeoutID) {
                state.timeoutID = clearTimeout(state.timeoutID);
            }

            // namespaced event used to register and unregister mousemove tracking
            var mousemoveEventName = _eventName("mousemove", instanceID);

            // Handle enter...
            if (event.type === 'mouseenter') {

                // Do nothing if already active
                if (state.isActive) {
                    return;
                }

                // set "previous" X and Y position based on initial entry point
                state.x = event.pageX;
                state.y = event.pageY;

                // Turn it off first to make sure we don't have it hooked up twice
                element
                    .off(mousemoveEventName, _onMouseMove)
                    .on(mousemoveEventName, _onMouseMove);

                // start polling interval (self-calling timeout) to _checkForHoverStart mouse coordinates over time
                state.timeoutID = setTimeout(
                    function () {
                        _checkForHoverStart(event, element, state, options);
                    },
                    options.hoverOverInterval);
            }

            // Handle leave...
            else {

                // Do nothing if not already active
                if (!state.isActive) {
                    return;
                }

                // Unbind expensive mousemove event
                element.off(mousemoveEventName, _onMouseMove);

                // Leaving the element... but we don't call the hoverOut until the timeout passes
                state.timeoutID = setTimeout(
                    function () {
                        _onHoverOut(event, element, state, options);
                    },
                    options.hoverOutDelay);
            }
        }

        // listen for mouseenter and mouseleave
        this.on({
            [_eventName("mouseenter")]: _handleHover,
            [_eventName("mouseleave")]: _handleHover
        });

        return this;
    }

    //
    // jQuery extension that clears the hover state, if any, if the element(s) in the jQuery object.  If currently in the hover state, then cancels the pending call 
    // to 'handlerOut' without triggering it at all, otherwise does nothing
    //
    function hoverClear() {

        // Go through each element in this jQuery object
        return this.each(function () {
            var element = $(this);
            var stateStorage = _getStateStorage(element);

            // There may be multiple instances if hoverIntent was called multiple times - we clear them all, since
            // there is no way to distinguish.
            for (var instanceID in stateStorage) {

                var state = _getState(element, instanceID);

                // clear any existing timeout
                if (state.timeoutID) {
                    state.timeoutID = clearTimeout(state.timeoutID);
                }

                stateStorage[state.instanceID] = null;
            }
        });
    }

    // Expose our public functions to jQuery objects
    jQuery.fn.extend({
        hoverIntent,
        hoverClear
    });

})(jQuery);
